import { ComponentProps } from 'react'
import styled from 'styled-components'
import icons from './icons'

interface Props extends ComponentProps<"svg"> {
  id: keyof typeof icons
}

const Icon = ({ id, name = 'Icon', width = 35, height = 35, ...rest }: Props) => {
  const Svg = icons[id]
  return <Svg className="icon" width={width} height={height} {...rest} />
}

export default styled(Icon)``
